export const IFTA_STATUSES = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    ERROR: 'ERROR',
    DONE: 'DONE',
};

export const GEOFENCING_COMPANIES_IDS = [1875, 2863, 2935, 1328, 3165, 2285, 3604];
export const GEOFENCING_PARTNERS_NAMES = ['JMS ASSOCIATES, LLC'];
